import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FeatureCheckModal from 'component/featureCheck/Modal'
import Glyph from 'component/utils/Glyph'
import iconDownload from 'images/icon-download.svg'

class FeatureCheckTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      featureCheck: {},
    }
    this.renderFeatureCheckModal = this.renderFeatureCheckModal.bind(this)
    this.toogleModal = this.toogleModal.bind(this)
    this.renderRows = this.renderRows.bind(this)
  }

  openFeatureCheckModal = (interfaces) => {
    this.setState({ featureCheckModal: true, interfaces })
  }

  toogleModal() {
    this.setState({ featureCheckModal: !this.state.featureCheckModal })
  }

  getTxt = (interfaces) => {
    const element = document.createElement('a')
    let status
    if (interfaces.tpStatus) {
      status = interfaces.tpStatus
    } else {
      status = '-'
    }

    const file = new Blob(
      [
        'Endpoint \n',
        interfaces.dsInterface,
        '\n Request \n',
        interfaces.dsParam,
        '\n Status \n',
        status,
        '\n Response \n',
        interfaces.dsReturn,
      ],
      { type: 'text/plain' }
    )
    element.href = URL.createObjectURL(file)
    element.download = 'Interface-Check.txt'

    // Required for this to work in FireFox
    document.body.appendChild(element)

    element.click()
    element.parentElement.removeChild(element)
  }

  renderFeatureCheckModal() {
    const { featureCheckModal, interfaces } = this.state
    const { translate } = this.props

    if (!featureCheckModal) {
      return
    }

    const props = {
      translate,
      closeModal: this.toogleModal,
    }

    return <FeatureCheckModal {...props} interfaces={interfaces} />
  }

  renderRows(interfaces, index) {
    return (
      <tr key={index}>
        <td className='align-left overflow-column-text small-width'>
          {interfaces.count ? interfaces.count : '-'}
        </td>
        <td className='align-left overflow-hidden-column overflow-column-text'>
          {interfaces.dsInterface ? interfaces.dsInterface : '-'}
        </td>
        <td className='align-center small-width'>
          {interfaces.cdParent ? interfaces.cdParent : '-'}
        </td>
        <td className='align-center option-width'>
          <a href='#' onClick={() => this.openFeatureCheckModal(interfaces)}>
            {interfaces.tpStatus === '200' ? (
              <Glyph type='checked' color='success' />
            ) : (
              <Glyph type='x' color='danger' />
            )}
          </a>
        </td>
        <td className='align-center option-width'>
          <a href='#' onClick={() => this.getTxt(interfaces)}>
            <img className='featureCheckTable-img-down' src={iconDownload} />
          </a>
        </td>
      </tr>
    )
  }

  render() {
    const { translate, interfaceCheckData } = this.props

    return (
      <div className='FeatureCheckTable'>
        <table className='table table-zebra margin-top-double table-layout-fixed'>
          <thead>
            <tr>
              <th className='align-left overflow-hidden-column small-width'>
                {translate('feature-check.id')}
              </th>
              <th className='align-left overflow-hidden-column'>
                {translate('feature-check.api')}
              </th>
              <th className='align-center overflow-hidden-column small-width'>
                {translate('feature-check.parent')}
              </th>
              <th className='align-center overflow-hidden-column option-width'>
                {translate('feature-check.status')}
              </th>
              <th className='align-center overflow-hidden-column option-width'>
                {translate('feature-check.download')}
              </th>
            </tr>
          </thead>
          <tbody>{interfaceCheckData.interfaces.map(this.renderRows)}</tbody>
        </table>
        {this.renderFeatureCheckModal()}
      </div>
    )
  }
}

FeatureCheckTable.propTypes = {
  interfaceCheckData: PropTypes.object,
  translate: PropTypes.func.isRequired,
}

export default FeatureCheckTable
